if (!customElements.get('compact-footer')) {
  customElements.define('compact-footer', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.groups = Array.from(this.querySelectorAll('details'));
      this.updateLayout = () => {
        this.groups.forEach(group => {
          group.open = this.desktop.matches;
          group.querySelector('summary').tabIndex = this.desktop.matches ? -1 : 0;
        });
      };
      this.keepDesktopOpen = event => {
        if (this.desktop.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.desktop.addEventListener('change', this.updateLayout);
      this.addEventListener('click', this.keepDesktopOpen);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.desktop.removeEventListener('change', this.updateLayout);
      this.removeEventListener('click', this.keepDesktopOpen);
    }
  });
}
